export const URL_CHAT_IMAGES =
    'https://www.myfreecams.com/php/user_chat_images.php?format=json'
export const URL_CONTACT_SUPPORT =
    'https://wiki.myfreecams.com/wiki/Contact_Support#Contact_support'
// note: for redirects, due to cokies for www site make sure the query string is left on
// or we can end up in a redirect loop
export const URL_MFC_DESKTOP = 'https://www.myfreecams.com/?dfwd=1'
export const URL_MFC_MOBILE = 'https://m.myfreecams.com'
export const URL_MFC_SHARE = 'https://share.myfreecams.com'
export const URL_MFC_SHARE_IFRAMES = `${URL_MFC_SHARE}/iframes/`
export const URL_MFC_SHARE_TIP_MENUS = `${URL_MFC_SHARE_IFRAMES}tipmenus/`
export const URL_MFC_SHARE_FEED = `${URL_MFC_SHARE}/feed`
export const URL_MFC_WIKI = 'https://wiki.myfreecams.com/wiki/Main_Page'
export const URL_PASSWORD_RESET =
    'https://www.myfreecams.com/php/account.php?request=password&mode=app&load=app&style=app'
export const URL_MFC_BECOME_MODEL = 'https://www.myfreecams.com/models'
export const URL_MFC_CONTENT_REMOVAL =
    'https://wiki.myfreecams.com/wiki/Take_It_Down_Act'
